import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  sendRequest,
  changeQueryParams,
  selectQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import SearchInput from '../../../../components/Common/Inputs/SearchInput';

class CostsRangeTaskInputs extends Component {
  changeQueryParams = changeParams => {
    this.props.changeQueryParams({ ...changeParams, ...{ page: 1 } });
    this.props.sendRequest();
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="panelGroupFilter_h_1">
          <a
            className="dropdown-toggle dropdown-toggle-collapse collapsed"
            role="button"
            data-toggle="collapse"
            href="#panelGroupFilter_c_1"
            aria-expanded="false"
            aria-controls="panelGroupFilter_c_1"
          >
            {t('Цена задания')}
          </a>
        </div>
        <div
          id="panelGroupFilter_c_1"
          className="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="panelGroupFilter_h_1"
        >
          <div className="panel-body">
            <div className="form-group form-group-sm m-b-0">
              <div className="input-group">
                <SearchInput
                  type="number"
                  className="form-control"
                  name="start"
                  onChange={e => {
                    this.changeQueryParams({ cost_from: e.target.value });
                  }}
                  value={this.props.selectQueryParams.cost_from}
                />
                <span className="input-group-addon">–</span>
                <SearchInput
                  type="number"
                  className="form-control"
                  name="start"
                  onChange={e => {
                    this.changeQueryParams({ cost_to: e.target.value });
                  }}
                  value={this.props.selectQueryParams.cost_to}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CostsRangeTaskInputs.propTypes = {
  // CONNECT
  selectQueryParams: PropTypes.shape({
    cost_from: PropTypes.string,
    cost_to: PropTypes.string
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(props.listReduceName)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CostsRangeTaskInputs)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskSearchForm/CostsRangeTaskInputs/CostsRangeTaskInputs.js